import Vue from 'vue';
import Rollbar from 'rollbar';
import get from 'lodash/get';
import set from 'lodash/set';
import { sanitizeRequestBody } from '../../utilities/sanitizeRequestBody';
import store from '../../store/index';

export const initializeRollbar = () => {
  const rollbar = new Rollbar({
    accessToken: process.env.ROLLBAR_KEY,
    captureUncaught: true,
    captureUnhandledRejections: true,
    checkIgnore: function (isUncaught, args, payload) {
      if (!args || !args[1] || !args[1].config) {
        return false;
      }

      // ignore vehicle image thumnmail network/timeout errors
      if (args[1].config.url.includes('/api/v2/vehicle_identities/image_urls') &&
        (args[1].originalMessage === 'Network Error' ||
        args[1].originalMessage === 'timeout exceeded' ||
        args[1].responseStatus >= 500)) {
        return true;
      }

      // ignore unleash timeout errors
      if (args[1].config.baseURL.includes('https://fast-track.unleash') &&
        args[1].originalMessage === 'Timeout') {
        return true;
      }

      return false;
    },
    filterTelemetry: function (e) {
      return e.type === 'network' &&
        (e.body.subtype === 'xhr' || e.body.subtype === 'fetch') &&
        e.body.url.includes('/version.json');
    },
    transform: function (payload) {
      // Sanitize payload data before it's sent
      [
        'body.trace.extra.config.data',
        'body.trace.extra.request.__sentry_xhr__.body',
        'custom.config.data',
        'custom.request.__sentry_xhr__.body'
      ]
        .filter((eventPath) => get(payload, eventPath))
        .forEach((eventPath) => {
          set(payload, eventPath, sanitizeRequestBody(get(payload, eventPath)));
        });
    },
    payload: {
      code_version: process.env.CURRENT_VERSION,
      environment: process.env.APP_ENV,
      client: {
        javascript: {
          code_version: process.env.CURRENT_VERSION,
          guess_uncaught_frames: true,
          source_map_enabled: true
        }
      },
      custom: {}
    },
    ignoredMessages: [
      /navigation cancelled/i,
      /script error/i
    ]
  });

  rollbar.configure({
    onSendCallback (isUncaught, args, item) {
      item.custom.brand = store.getters['leadChannel/brand'];
      item.custom.features = store.getters['feature/currentFeatureFlagStates'];
      item.custom.connection = {
        online: store.getters['connection/isOnlineAsString'],
        networkStatus: store.getters['connection/networkStatus']
      };
    }
  });

  Vue.rollbar = rollbar;
  Vue.prototype.$rollbar = Vue.rollbar;
};
